import React from 'react';

const BS_Typography = () => {
    return (
        <div>
            <h1>BS_Typography Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Typography;
